export default __webpack_public_path__ + "static/media/logo-xl-1920w.fe3b0a3f.png";